export default "__VITE_ASSET__52d92e84__"